import {actions} from 'src/app/modules/auth/redux/actions'

let isLoggingOut = false

export default function setupAxios(axios: any, store: any) {
  axios.defaults.headers.Accept = '*/*'

  axios.interceptors.request.use(
    (config: any) => {
      const {
        auth: {accessToken, guestToken},
      } = store.getState()

      if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`
      } else if (guestToken) {
        config.headers.Authorization = `Bearer ${guestToken}`
      }

      return config
    },
    (err: any) => Promise.reject(err)
  )

  axios.interceptors.response.use(
    (response: any) => response,
    (error: any) => {
      if (error?.response?.status === 401 && !isLoggingOut) {
        isLoggingOut = true
        store.dispatch(actions.logout())
        localStorage.clear()
        sessionStorage.clear()
        window.location.replace('/auth/login')
      }
      return Promise.reject(error)
    }
  )
}
